export default function IsRequired() {
  return <span className="text-danger"> *</span>;
}
